module.exports = __webpack_public_path__ + "static/media/dummy-profile-pic.f41d91c6.png";